import { render, staticRenderFns } from "./ServiceOrdersExtranet.vue?vue&type=template&id=05074222"
import script from "./ServiceOrdersExtranet.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersExtranet.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrdersExtranet.vue?vue&type=style&index=0&id=05074222&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports